export default __webpack_public_path__ + "static/media/ic_stopwatch_white.ec0fb0b7.svg";